export default {
	title: "Importación de Datos",
	subtitle: "Importe consultantes desde hojas de cálculo XLSX",
	downloadTemplate: "Descargar Plantilla",
	uploadFile: "Subir Archivo",
	maxSize: "Tamaño máximo: {size}MB",
	preview: "Vista Previa",
	confirm: "Confirmar Importación",
	validRows: "{count} fila(s) válida(s)",
	invalidRows: "{count} fila(s) con errores",
	totalRows: "{count} fila(s) en total",
	editableHint: "Revise los nombres a continuación. Puede editar el Nombre y Apellido directamente en la tabla antes de importar.",
	skippedRowsHint: "{count} fila(s) con errores no serán importadas. Corrija y reenvíe la hoja de cálculo o importe estos registros posteriormente.",
	success: "{count} persona(s) importada(s) con éxito",
	partialSuccess: "{imported} de {total} persona(s) importada(s)",
	goBack: "Volver",
	errors: {
		fileTooLarge: "Archivo demasiado grande. Máximo {size}MB",
		importFailed: "Error al importar datos",
	},
	result: {
		title: "Resultado de la Importación",
		viewConsultants: "Ver Consultantes",
		importMore: "Importar Más",
	},
	steps: {
		upload: "Subir",
		preview: "Revisar",
		result: "Resultado",
	},
	template: {
		instructionsText: "Complete los datos siguiendo la plantilla y suba el archivo para revisión.",
	},
};
